import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import './RecurringContributeWhatsNext.scss';

import config from '../../../../config/config';
import ConfirmationExitBox from '../../ConfirmationExitBox';
import { collegeGiftingPortals } from '../../../../settings/settings';
import DollarSignMonitor from '../../../Shared/Icons/DollarSignMonitor.image';
import SellDashboard from '../../../Shared/Icons/SellDashboard.image';
import CollegeGiftingPortal from '../../../Shared/Icons/CollegeGiftingPortal.image';
import { getCollegePlanType } from '../../../../redux/modules/productTypes/productType.selectors';
import Note from '../../../Shared/Note/Note';
import TRP from '../../../Shared/TRP/TRP';

export const RecurringContributeWhatsNext = ({ collegeConfirmType }) => (
  <div className="recurring-contribute-whats-next-exit-container">
    <div>
      <div className="recurring-contribute-whats-next-exit-heading">
        What's next?
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-another-trade'}
            className={'e2e-confirm-another-trade'}
            heading={'Add or Edit Recurring'}
            subHeading={
              'Scheduling automatic contributions makes adding to your portfolio simple.'
            }
            image={<DollarSignMonitor />}
            exitLocation={`${config.url}/usis/transactions/automatic`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-gifting-portal'}
            className={'e2e-confirm-gifting-portal'}
            heading={'Visit the Gifting Portal'}
            subHeading={
              <span>
                Friends and family can contribute to your child's 529 using the{' '}
                <strong>
                  GoTuition<sup>&reg;</sup>
                </strong>{' '}
                portal.
              </span>
            }
            image={<CollegeGiftingPortal />}
            exitLocation={`${config.url}/usis/go-tuition-profile/${collegeGiftingPortals[collegeConfirmType]}/dashboard`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-view-dashboard'}
            className={'e2e-confirm-view-dashboard'}
            heading={'View Dashboard'}
            subHeading={`Review your portfolio and track how your investments are performing.`}
            image={<SellDashboard />}
            exitLocation={`${config.url}/usis/my-accounts/dashboard`}
          />
        </div>
      </div>
    </div>
    <hr className="recurring-contribute-whats-next-disclaimer-separator" />
    <Note title="GoTuition">
      is a trademark of <TRP /> Group, Inc.
    </Note>
  </div>
);

const mapStateToProps = (state) => {
  return {
    collegeConfirmType: getCollegePlanType(state),
  };
};

export default compose(connect(mapStateToProps))(RecurringContributeWhatsNext);
